import {
  createServiceApiRequest,
  deleteServiceApiRequest,
  getArchivedServices,
  getOneTimeApiRequest,
  toggleActiveStatusApiRequest,
  updateServiceApiRequest,
} from '@guryou/api-client';

import { executeApiCall } from '../core';
import {
  PROVIDER_ADD_SERVICE,
  PROVIDER_ARCHIVE_SERVICE,
  PROVIDER_ARCHIVED_SERVICES_GET_MANY,
  PROVIDER_SERVICE_ACTIVE_STATUS,
  PROVIDER_UPDATE_SERVICE,
} from '../new/service';
import { PROVIDER_GET_ONETIME } from '../types';

const getProviderOneTime = silent => async dispatch =>
  dispatch(executeApiCall(getOneTimeApiRequest(), PROVIDER_GET_ONETIME, silent, undefined, true));

const toggleActiveStatus = id => async dispatch => dispatch(executeApiCall(toggleActiveStatusApiRequest(id), PROVIDER_SERVICE_ACTIVE_STATUS));

const createService = data => async dispatch => dispatch(executeApiCall(createServiceApiRequest(data), PROVIDER_ADD_SERVICE));

const updateService = data => async dispatch => dispatch(executeApiCall(updateServiceApiRequest(data), PROVIDER_UPDATE_SERVICE));

const deleteService = (id, status) => async dispatch => dispatch(executeApiCall(deleteServiceApiRequest(id, status), PROVIDER_ARCHIVE_SERVICE));

const getProviderArchivedServices = type => async dispatch =>
  dispatch(executeApiCall(getArchivedServices(type), PROVIDER_ARCHIVED_SERVICES_GET_MANY, ...[undefined, undefined], true));

export { createService, deleteService, getProviderArchivedServices, getProviderOneTime, toggleActiveStatus, updateService };
